import { Typography, lighten, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SwishConsent } from '../models/swishConsent';

type SwishConsentStatusProps = {
  item: SwishConsent;
};

// Status-chip för Swish-medgivanden, speglar AutogiroMandateStatus (färgad prick + etikett).
export const SwishConsentStatus = (props: SwishConsentStatusProps) => {
  const { item } = props;
  const { t } = useTranslation(['invoice']);

  const thm = useTheme();

  let bgColor = `${thm.palette.grey[200]}`;
  let textColor = `${thm.palette.text.primary}`;
  let statusDotColor = `${thm.palette.grey[400]}`;
  let border = 'none';

  switch (item.status) {
    case 'ACTIVE':
      bgColor = `${lighten(thm.palette.success.main, 0.9)}`;
      statusDotColor = `${thm.palette.success.main}`;
      break;
    case 'CREATED':
    case 'SIGNING':
    case 'PENDING':
      bgColor = `${lighten(thm.palette.warning.main, 0.8)}`;
      statusDotColor = `${thm.palette.warning.main}`;
      border = `1px solid ${thm.palette.warning.main}`;
      break;
    case 'TIMEOUT':
    case 'DECLINED':
      bgColor = `${lighten(thm.palette.error.main, 0.9)}`;
      statusDotColor = `${thm.palette.error.main}`;
      break;
    case 'DELETED':
    case 'REVOKED':
      bgColor = `${thm.palette.grey[200]}`;
      textColor = `${thm.palette.text.secondary}`;
      statusDotColor = `${thm.palette.grey[400]}`;
      break;
    default:
      break;
  }

  // Översätt statusvärdet med fallback till råvärdet.
  const key = `invoice:swishStatus.consentStatusValues.${item.status}`;
  const translated = t(key);
  const label = translated === key ? item.status : translated;

  return (
    <Typography
      variant='body2'
      sx={{
        position: 'relative',
        fontSize: '0.8rem',
        backgroundColor: bgColor,
        color: textColor,
        boxSizing: 'border-box',
        borderRadius: 1,
        pl: 2.75,
        pr: 1,
        py: 0.25,

        '&::after': {
          position: 'absolute',
          content: '" "',
          top: '50%',
          left: thm.spacing(1),
          mt: '-4px',
          backgroundColor: statusDotColor,
          border,
          width: '8px',
          height: '8px',
          borderRadius: '500rem',
        },
      }}
    >
      {label}
    </Typography>
  );
};
